function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#414141",
  d: "M13.6 11.25c-1.153 0-1.708.625-3.6.625-1.892 0-2.443-.625-3.6-.625-2.981 0-5.4 2.352-5.4 5.25v1.625C1 19.16 1.864 20 2.929 20H17.07c1.066 0 1.93-.84 1.93-1.875V16.5c0-2.898-2.419-5.25-5.4-5.25zm4.114 6.875a.636.636 0 0 1-.643.625H2.93a.636.636 0 0 1-.643-.625V16.5c0-2.207 1.844-4 4.114-4 .787 0 1.571.625 3.6.625 2.025 0 2.813-.625 3.6-.625 2.27 0 4.114 1.793 4.114 4v1.625zM10 10c2.84 0 5.143-2.238 5.143-5S12.84 0 10 0 4.857 2.238 4.857 5 7.16 10 10 10zm0-8.75c2.125 0 3.857 1.684 3.857 3.75S12.125 8.75 10 8.75 6.143 7.066 6.143 5 7.875 1.25 10 1.25z"
});

var SvgUserInline = function SvgUserInline(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default SvgUserInline;